$('.js-toggle-accordion')
	.find('.accordion__head')
	.on('click', function(e) {
		e.preventDefault();
		const $this = $(this);
		$this
			.next()
			.slideToggle()
			.parents('.accordion')
			.toggleClass('accordion--toggled');
	});
